import React from 'react';
import { useVoiceDemo } from '../utils/useExclusiveAudio';
import { FaPhone, FaMicrophone } from 'react-icons/fa';
import './LiveDemoStrip.css';

const PHONE_DISPLAY = '(424) 434-4541';
const PHONE_TEL = 'tel:+14244344541';

function track(event, location) {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', event, { location });
  }
  if (event === 'demo_call_click' && typeof window !== 'undefined' && window.fbq) {
    window.fbq('trackCustom', 'DemoCallClick', { location });
  }
}

function LiveDemoStrip({ location = 'strip', heading = "Don't take our word for it. Talk to the AI yourself." }) {
  const { open, toggle } = useVoiceDemo();

  return (
    <section className="demo-strip" aria-label="Live AI demo">
      <div className="demo-strip-inner">
        <p className="demo-strip-heading">{heading}</p>
        <div className="demo-strip-actions">
          <div className="demo-strip-action">
            <a
              href={PHONE_TEL}
              className="demo-strip-call"
              onClick={() => track('demo_call_click', location)}
            >
              <FaPhone aria-hidden="true" /> Call {PHONE_DISPLAY}
            </a>
            <span className="demo-strip-note">Our AI answers. Seriously.</span>
          </div>
          <div className="demo-strip-action">
            <button
              type="button"
              className="demo-strip-talk"
              aria-expanded={open}
              onClick={() => {
                toggle();
                track('tara_open', location);
              }}
            >
              <FaMicrophone aria-hidden="true" /> {open ? 'Close voice demo' : 'Talk to it in your browser'}
            </button>
            <span className="demo-strip-note">Takes 30 seconds · No signup · Hang up whenever</span>
          </div>
        </div>
        {open && (
          <div className="demo-strip-widget">
            <elevenlabs-convai agent-id="agent_0701k6238fn5ex58es31xvqvs868"></elevenlabs-convai>
          </div>
        )}
      </div>
    </section>
  );
}

export default LiveDemoStrip;
